import { urlMaker } from 'modules/utils/urlMaker'

export const usContractsEndpoints = {
  usContracts: urlMaker('/contracts/'),
  usContractsActualNew: '/contracts/actual/?status=new',
  usContractsActualSigned: '/contracts/actual/?status=signed',
  usContractsCancelledNew: '/contracts/cancelled/?status=new',
  usContractsCancelledSigned: '/contracts/cancelled/?status=signed',
  closeUsContract: (id: number) => `/contracts/${id}/cancel/`,
  signUsContract: (id: number) => `/contracts/${id}/sign/`,
  usContractAllowCreditLimitExceed: (id: number) => `/contracts/${id}/approve-credit-limit-overdraft/`,
  usContractAllowPositionLimitExceed: (id: number) => `/contracts/${id}/approve-position-limit-overdraft/`,
  usContactsTotal: () => '/contracts/totals/',
  contractLongPositions: () => '/contracts/positions/actual/?contract_type=purchase',
  contractShortPositions: () => '/contracts/positions/actual/?contract_type=sale',
}
